import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

const COMPLIANCE_BADGE_KEYS = [
  'compliance.badges.lpdp',
  'compliance.badges.encryption',
  'compliance.badges.rbac',
  'compliance.badges.traceability',
] as const;

interface ComplianceBadgesProps {
  className?: string;
  badgeClassName?: string;
}

export function ComplianceBadges({
  className,
  badgeClassName,
}: ComplianceBadgesProps): React.JSX.Element {
  const { t } = useTranslation('proof');

  return (
    <div className={cn('flex flex-wrap gap-3', className)}>
      {COMPLIANCE_BADGE_KEYS.map((key) => (
        <span
          key={key}
          className={cn(
            'rounded-full border border-brand-primary/10 bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.08em] text-[var(--ir-muted)]',
            badgeClassName
          )}
        >
          {t(key)}
        </span>
      ))}
    </div>
  );
}
